module.exports = __webpack_public_path__ + "img/image-interview.b682e437.svg";